// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3JW5H","heading":"Header_heading__uKjEY","subheading":"Header_subheading__1XIDU","partnerLogo":"Header_partnerLogo__27gdO"};